import { render, staticRenderFns } from "./ProblemForm.vue?vue&type=template&id=143cc03c&scoped=true&"
import script from "./ProblemForm.vue?vue&type=script&lang=js&"
export * from "./ProblemForm.vue?vue&type=script&lang=js&"
import style0 from "./ProblemForm.vue?vue&type=style&index=0&id=143cc03c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "143cc03c",
  null
  
)

export default component.exports